export default {
  strict: true,
  namespaced: true,
  state: {
    notes: {
      list: [],
      noteDeleteId: 0
    }
  },
  mutations: {
    resetNotes (state) {
      state.notes.list = []
      state.notes.noteDeleteId = 0
    },
    addNotes (state, value) {
      state.notes.list.push(value)
    },
    addNewNotes (state, value) {
      state.notes.list.unshift(value)
    },
    setNoteDeleteId (state, value) {
      state.notes.noteDeleteId = value
    },
    updateNote (state, value) {
      let i = state.notes.list.findIndex(x => x.id === value.id)
      if (i !== -1) {
        state.notes.list[i].message = value.message
        state.notes.list[i].status = value.status
      }
    },
    deleteNote (state, value) {
      let i = state.notes.list.findIndex(x => x.id === value)
      if (i !== -1) {
        state.notes.list.splice(i, 1)
      }
    }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/reservation-details/notes.js